import { createSelector } from 'reselect';
import _ from 'lodash';

import BuilderSlx  from 'app/selectors/company-admin/builder-bracket';

const selBracket = createSelector(
  [BuilderSlx.saveAttrs],
  (saveAttrs) => {
    return {
      isDraft: true,
      ...saveAttrs,
    };
  }
);

export default {
  bracket: selBracket,
};
